import { computed, Injectable, signal } from "@angular/core";
import { Job } from "../../models/job";

// Session-scoped favourite jobs, shared between the project tab bar and the
// model page (e.g. batch screenshots). Cleared when the active project changes,
// matching the previous component-local behaviour.
@Injectable({ providedIn: "root" })
export class FavJobsService {
  private projectId: string | null = null;

  readonly favJobs = signal<Job[]>([]);
  readonly hasFavJobs = computed(() => this.favJobs().length > 0);

  setProject(projectId: string) {
    if (this.projectId !== projectId) {
      this.projectId = projectId;
      this.favJobs.set([]);
    }
  }

  has(jobId: string): boolean {
    return this.favJobs().some((j) => j.id === jobId);
  }

  add(job: Job) {
    if (this.has(job.id)) return;
    this.favJobs.update((jobs) => [...jobs, job]);
  }

  remove(jobId: string) {
    this.favJobs.update((jobs) => jobs.filter((j) => j.id !== jobId));
  }

  shift(jobId: string, direction: -1 | 1) {
    this.favJobs.update((jobs) => {
      const index = jobs.findIndex((j) => j.id === jobId);
      const target = index + direction;
      if (index === -1 || target < 0 || target >= jobs.length) return jobs;
      const next = [...jobs];
      [next[index], next[target]] = [next[target], next[index]];
      return next;
    });
  }
}
